module.exports = __webpack_public_path__ + "static/media/plus-icon.c0dc6659.svg";